// Cores de destaque usadas nas grades (corLinha/corFonte). Cada cor conhecida vira um token CSS
// com a cor original como fallback: o tema claro não muda e o tema escuro redefine o token.
const TOKENS_LINHA: Record<string, string> = {
    'lightgray': '--grade-linha-inativa',
    '#fbe2e0': '--grade-linha-erro',
    '#ffffcc': '--grade-linha-alerta',
    'aliceblue': '--grade-linha-info',
};

const TOKENS_FONTE: Record<string, string> = {
    'gray': '--grade-texto-inativo',
    'steelblue': '--grade-texto-info',
};

const comTema = (tokens: Record<string, string>) => (cor: string | undefined): string | undefined => {
    const normalizada = cor?.trim().toLowerCase();
    const token = normalizada && tokens[normalizada];
    return token ? `var(${token}, ${normalizada})` : cor;
};

export const corLinhaComTema = comTema(TOKENS_LINHA);
export const corFonteComTema = comTema(TOKENS_FONTE);
